// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {getOpenServiceIntervals} from '../../../shared/repositories';
import {updateServiceInterval} from './claim-details';

export const readOpenServiceIntervals = (planName, claim) =>

    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const currentServiceInterval = getState().claims.maintenancePlan.claim.serviceInterval.key;

        try {

            const data = await getOpenServiceIntervals(planName, claim);

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_OPEN_SERVICE_INTERVALS
            });

            if (data.length === 1 && !currentServiceInterval) {

                dispatch(updateServiceInterval(data[0].key, data));

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/get-open-service-intervals.js